<template>
    <div class="location">
        <img class="building-icon" src="../assets/img/map.png" alt="">
        <div class="red-icon" :class="'pos'+redIconPosition">
            <img src="../assets/img/location.png" alt="">
        </div>
        
    </div>
</template>
<style>
.location{
    width: 0.875rem;
    height: 0.41rem;
    background:rgba(000, 000, 000, 0.3);
    position:absolute;
    left: -0.09rem;
    bottom: 0.05rem;
    border-radius:4px;
}
.location:after{
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 0.05rem;
    top: 100%;
    border: 0.04rem solid transparent;
    border-top-color: rgba(000, 000, 000, 0.3);
}


.location .building-icon{
    margin: 0.07rem 0 0 0.17rem;
    width: 0.58rem;
    height: auto;
}
.red-icon{
    position: absolute;
    width:0.05rem;
    left: 45%;
    bottom: 28%;
}
.red-icon img {
    width:0.04rem;
}
.pos0{
    left: 45%;
    bottom: 28%;
} 
.pos4{
    bottom: 9%;
    left: 67%;
} 
.pos5{
    left: 66%;
    bottom: 22%;
} 
.pos7{
    left: 66%;
    bottom: 49%;
}  
.pos8{
    left: 56%;
    bottom: 28%;
} 
.pos9{
    left: 50%;
    bottom: 52%;
} 
.pos10{
    left: 43%;
    bottom: 52%;
} 
.pos11{
    left: 43%;
    bottom: 46%;
} 
.pos12{
    left: 35%;
    bottom: 28%;
} 
.pos13{
    left: 36%;
    bottom: 51%;
}  
.pos15{
    left: 22%;
    bottom: 52%;
}
.pos14{
    left: 26%;
    bottom: 28%;
}
.pos16{
    left: 24%;
    bottom: 17%;
}
.pos17{
    left: 34%;
    bottom: 2%;
}


</style>
<script>

export default {
    components: {
        
    },

    props:[
        'redIconPos'
    ],
    data(){
        return{
            redIconPosition: this.redIconPos
        }
    },
}
</script>
